import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=0ded1b02&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=0ded1b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded1b02",
  null
  
)

export default component.exports